import { useI18n } from "providers/I18n"

type Props = {
  code?: string
}

export const CodeSublabel = (props: Props) => {
  const { t } = useI18n()
  const { code } = props

  return (
    <div>
      <span className={"BodyBody-xsDark-greyRegular"}>{t("code")}: </span>
      <span className={"BodyBody-xsBlackRegular"}>{code}</span>
    </div>
  )
}
